import { styled, Grid } from '@mui/material';
import { Button } from '@totalsoft/rocket-ui';

export const ClientWrapper = styled(Grid)(({ theme }) => ({
  gap: theme.spacing(0)
}));

export const AddressTypeButton = styled(Button)(() => ({
  borderRadius: 0,
  justifyContent: 'start'
}));
